module.exports = __webpack_public_path__ + "img/BMS_Header.d4166a3c.png";